// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as Turbo from "@hotwired/turbo"
import "./controllers"

// Use custom confirm modal instead of browser's confirm()
Turbo.setConfirmMethod((message) => {
  if (window.confirmController) {
    return window.confirmController.show(message)
  }
  // Fallback to browser confirm if controller not available
  return Promise.resolve(window.confirm(message))
})
